// extracted by mini-css-extract-plugin
module.exports = {"videoGalleryPage":"VideoGalleryPage_videoGalleryPage__1ytp3"};